import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Title5 } from "@churchofjesuschrist/eden-headings";
import { spacing32, spacing16, info40, breakWidth600, boxShadowRaised } from "@churchofjesuschrist/eden-style-constants";
import SubNavigationNav from "./components/SubNavigationNav";
const Flex = styled.div.withConfig({
  componentId: "sc-3c9j64-0"
})(["display:flex;justify-content:space-between;flex-wrap:wrap;box-shadow:", ";padding-block-start:", ";"], boxShadowRaised, spacing16); // The large flex-grow allows us to push the Track to the end while
// still having Track being aligned with the start.

const TitleWrapper = styled.div.withConfig({
  componentId: "sc-3c9j64-1"
})(["flex:100 1 auto;display:flex;"]);
const sharedTitleStyles = css(["color:inherit;margin:0 ", ";padding:0 0 ", ";display:flex;align-items:center;@media (min-width:", "){margin:0 ", ";padding:0 0 ", ";}"], spacing16, spacing16, breakWidth600, spacing32, spacing16);
const TitleWithLink = styled.a.withConfig({
  componentId: "sc-3c9j64-2"
})(["text-decoration:none;", " &:hover{color:", ";}"], sharedTitleStyles, info40);
const TitleWithoutLink = styled.div.withConfig({
  componentId: "sc-3c9j64-3"
})(["", ""], sharedTitleStyles);
const StyledNav = styled(SubNavigationNav).withConfig({
  componentId: "sc-3c9j64-4"
})(["flex:1 0 auto;max-width:100%;"]);

const SubNavigation = _ref => {
  let {
    title = {},
    items,
    ...rest
  } = _ref;
  const {
    text,
    ...titleRest
  } = title;
  const Title = title.href ? TitleWithLink : TitleWithoutLink;
  return /*#__PURE__*/React.createElement("nav", rest, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(TitleWrapper, {
    "data-testid": "title-wrapper"
  }, text ? /*#__PURE__*/React.createElement(Title, titleRest, /*#__PURE__*/React.createElement(Title5, null, text)) : null), /*#__PURE__*/React.createElement(StyledNav, {
    items: items
  })));
};

SubNavigation.propTypes = {
  /** The title portion of the navigation */
  title: PropTypes.shape({
    /** The text label of the title */
    text: PropTypes.string.isRequired,

    /** The URL the title should link to */
    href: PropTypes.string
  }),

  /** Navigation items with this shape
  ```js
  {
    // The text label of the navigation item
    text: 'Follow',
     // The URL the navigation item should link to if it has no children navigation items
    href: '#',
     // Whether this navigation item is currently active
    current: false,
     // Children navigation items
    items: [
      {
        // The text label of the child navigation item
        text: 'Twitter',
         // The URL the child navigation item should link to
        href: 'https://twitter.com',
         // Whether this navigation item is currently active
        current: true,
      }
    ]
  }
  ```
  */
  items: PropTypes.array.isRequired
};
export default SubNavigation;